import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from "./Form.js";
import ContentWithImages from "./ContentWithImages.js";
import DoctorBite from "../../DoctorBite.js";
import PatientReviews from "../../PatientReview.js";
import TeamSection from './TeamSection'
import GetInTouch from "../../GetInTouch.js";
import FollowYt from "../../FollowYt.js";
import Counter from "../../../NumCounter.js";
import Breadcrumb from "../../Breadcrum.js";

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
      <Helmet>
      <title>Audiology Services in Delhi, India | Hearing Tests, Treatment, Audiologist, Clinic</title>
      <meta name="description" content="Get professional audiology services in Delhi, India. Learn about hearing tests, hearing loss treatment, and expert ENT care at MedFirst ENT Centre." />
      <meta name="keywords" content="audiology Delhi, hearing test Delhi, hearing care center, audiologist Delhi" />
      <link rel="canonical" href="" />
      <meta property="og:title" content="Audiology Services in Delhi, India | Hearing Tests, Treatment, Audiologist, Clinic" />
      <meta property="og:description" content="Get professional audiology services in Delhi, India. Learn about hearing tests, hearing loss treatment, and expert ENT care at MedFirst ENT Centre." />
      <meta name="robots" content="index, follow" />
      {/* You can add more meta tags as needed */}
    </Helmet>
     <main>
        <Breadcrumb/>
        <Form />  
        <Counter />
        <ContentWithImages />
		<TeamSection/>
        <FollowYt />
        <DoctorBite />
        <PatientReviews />
        
        <GetInTouch />
      </main>
    </div>
  );
}
